<template>
  <div>
    <a-tabs v-model="active" v-if="name && formConfig && formConfig.length > 0">
      <a-tab-pane key="0" :tab="name" name="properties">
        <component :is="(selectNode.type||'').toLowerCase()" :config="selectNode.props"/>
      </a-tab-pane>
      <el-tab-pane key="1" tab="表单权限设置" name="permissions" v-if="false">
        <form-authority-config/>
      </el-tab-pane>
    </a-tabs>
    <component :is="(selectNode.type||'').toLowerCase()" v-else :config="selectNode.props"/>
  </div>
</template>

<script>
import Approval from './ApprovalNodeConfig.vue'
import Condition from './ConditionNodeConfig.vue'
import Concurrent from './ConcurrentNodeConfig.vue'
import Delay from './DelayNodeConfig.vue'
import Cc from './CcNodeConfig.vue'
import Trigger from './TriggerNodeConfig.vue'
import FormAuthorityConfig from './FormAuthorityConfig.vue'
import Root from './RootNodeConfig.vue'

export default {
  name: 'NodeConfig',
  components: {
    Approval,
    Condition,
    Concurrent,
    Trigger,
    Delay,
    Root,
    Cc,
    FormAuthorityConfig
  },
  data () {
    return {
      active: '0'
    }
  },
  computed: {
    selectNode () {
      return this.$store.state.oaApprove.selectedNode
    },
    formConfig () {
      return this.$store.state.oaApprove.design.formItems
    },
    name () {
      switch (this.selectNode.type) {
        case 'ROOT':
          return '设置发起人'
        case 'APPROVAL':
          return '设置审批人'
        case 'CC':
          return '设置抄送人'
        default:
          return null
      }
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>

</style>
